import React from 'react'
import { ArrowRight } from "lucide-react"; // ✅ PascalCase
import Button from '../Button/Button.jsx'
import './CardTest.css'

const CardTest = ({title, img, paragraph, textButton, typeCard}) => {

  return (
    <div className='container-test' >
      <h2 className={`title-tilte ${typeCard}`}>{title}</h2>
      <img src={img} alt={title} className='test-img'/>
      <p className='test-description'>{paragraph}</p>
      <button className={`btn-test ${typeCard}`}>{textButton}  <span className="circle-arrow"><ArrowRight /></span></button>
    </div>
  )
}

export default CardTest
